module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-align",
    attrs: {
      "id": "homepage"
    }
  }, [_c('span', {
    staticClass: "white-text"
  }, [_vm._v("\n    Aby kontynuować musisz się zalogować:\n  ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Zaloguj się")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c127d89c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
// module id = 401
// module chunks = 0